import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const CommercialInvoices = lazy(() => import('../components/other/commercial-invoices/CommercialInvoices'));
const OPLOGInvoiceDrop = lazy(() => import('../components/other/oplog-invoices'));
const GardnersInvoices = lazy(() => import('../components/other/gardners-invoices'));
const DistributorInvoices = lazy(() => import('../components/distributor-invoices'));
const PublisherDiscounts = lazy(() => import('../components/publishers/publisher-discounts/PublisherDiscounts'));
const NegotiationLogging = lazy(() => import('../components/other/negotiation-logging/NegotiationLogging'));

export const otherRoutes = (
  <>
    <Route path="/commercial-invoices" element={<CommercialInvoices />} />
    <Route path="/oplog-invoices" element={<OPLOGInvoiceDrop />} />
    <Route path="/gardners-invoices" element={<GardnersInvoices />} />
    <Route path="/distributor-invoices" element={<DistributorInvoices />} />
    <Route path="/negotiation-logging" element={<NegotiationLogging />} />
    <Route path="/publisher-discounts" element={<PublisherDiscounts />} />
  </>
);
